import React from 'react';
function ArrowW({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M5.62539 13.1251L2.50028 9.99999L5.62538 6.87489"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.5005 10L2.50049 10" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.3755 13.125L17.5005 10L14.3755 6.87499"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ArrowW;
